import { Injectable } from '@angular/core';
import * as Shopify from 'shopify-buy';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/publish';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'

@Injectable()
export class ShopService {
  private client;
  public products;
  public checkout;

  public addToCart(items: object[]) {
    let promise = new Promise((resolve, reject) => {
      // Add an item to the checkout
      this.client.checkout.addLineItems(this.checkout.id, items).then((checkout) => {
        this.checkout = checkout;
        resolve(true);
      }).catch(reject);
    });
    return promise;

  }

  public createCheckout(): void {
    // Create an empty checkout
    this.client.checkout.create().then((checkout) => {
      // Do something with the checkout
      this.checkout = checkout;
      window.localStorage.setItem("cartID", checkout.id);
    }).catch((err) => {
      console.error("createCheckout: ", err);
    });
  }
  public setCheckout(id: string): void {
    this.client.checkout.fetch(id).then((checkout) => {
      // Do something with the checkout
      if (!checkout.completedAt) {
        this.checkout = checkout;
      } else this.createCheckout();
    }).catch((err) => {
      console.error("setCheckout: ", err);
      this.createCheckout();
    });
  }

  public removeItem(id: string): void {
    // Remove an item from the checkout
    this.client.checkout.removeLineItems(this.checkout.id, [id]).then((checkout) => {
      // Do something with the updated checkout
      this.checkout = checkout;
    }).catch(console.error);
  }

  public updateQty(id: string, qty: number) {
    let promise = new Promise((resolve, reject) => {

      this.client.checkout.updateLineItems(this.checkout.id, { id: id, quantity: qty }).then((checkout) => {
        this.checkout = checkout;
        resolve(true);
        // Do something with the updated checkout
      }).catch(reject);
    });
    return promise;
    // Update the line item on the checkout (change the quantity or variant)

  }


  public getProduct = function (id) {
    if (!this.client) {
      this.client = Shopify.buildClient({
        domain: 'bender-hardware.myshopify.com',
        storefrontAccessToken: 'afeab19bbce84383fa1d6129ac04de0a'
      });
    }
    return this.client.product.fetchByHandle(id);
  }

  public getProductServerside(id):any {
      return this._http.get('https://www.benderhardware.com/api/product/' + id)
      .map((res: Response) => res.json());
  }
 
  // public getHomepageProducts() {
  //   if (!this.client) {
  //     this.client = Shopify.buildClient({
  //       domain: 'bender-hardware.myshopify.com',
  //       storefrontAccessToken: 'afeab19bbce84383fa1d6129ac04de0a'
  //     });
  //   }
  //   return this.client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzM0NTU2MDg0Mjg0");
  //   // return this.client.product.fetchQuery({
  //   //   collection_id: "34556084284"
  //   // });
  //   // return this.client.collection.fetch("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzM0NTU2MDg0Mjg0").products.fetchAll();
  // }

  // public getHomepageProductsServerside():any {
  //   return this._http.get('https://www.benderhardware.com/api/homepage-products')
  //   .map((res: Response) => res.json());
  // }

  public getProducts = function () {
    if (!this.client) {
      this.client = Shopify.buildClient({
        domain: 'bender-hardware.myshopify.com',
        storefrontAccessToken: 'afeab19bbce84383fa1d6129ac04de0a'
      });
    }
    return this.client.product.fetchQuery({ sortKey: 'CREATED_AT', reverse: true});
  }

  public getProductsServerside():any {
    return this._http.get('https://www.benderhardware.com/api/products')
    .map((res: Response) => res.json());
  }
  
  constructor(private _http:Http) {
    this.client = Shopify.buildClient({
      domain: 'bender-hardware.myshopify.com',
      storefrontAccessToken: 'afeab19bbce84383fa1d6129ac04de0a'
    });

  }

  ngOnInit() {
    this.client = Shopify.buildClient({
      domain: 'bender-hardware.myshopify.com',
      storefrontAccessToken: 'afeab19bbce84383fa1d6129ac04de0a'
    });
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/shop.service.ts